import { type FC } from 'react'
import { type Control, useWatch } from 'react-hook-form'
import { differenceInCalendarDays } from 'date-fns'

import DatePicker from '@DS/components/components/datePicker/DatePicker'
import { type DatePickerProps } from '@DS/components/components/datePicker/DatePicker.types'
import { transformDate } from '@Utils/datepicker'

import { type JourneyDatePickerFormData } from '../JourneyDatePicker.types'

export type ControlDatePickerProps = Pick<
  DatePickerProps,
  'initTarget' | 'maxDate' | 'mode' | 'numberOfMonths' | 'onChange' | 'restrictedDatesList'
> & {
  control: Control<JourneyDatePickerFormData>
} & Partial<Pick<DatePickerProps, 'scrollElementRef'>>

const ControlDatePicker: FC<ControlDatePickerProps> = ({
  control,
  numberOfMonths,
  onChange,
  restrictedDatesList,
  scrollElementRef,
  ...rest
}) => {
  const [startDate, endDate] = useWatch<JourneyDatePickerFormData>({
    control,
    name: ['startDate', 'endDate'],
  })

  const transformedStartDate = transformDate(startDate)
  const transformedEndDate = transformDate(endDate)

  const hasEndDate = endDate && differenceInCalendarDays(transformedStartDate, transformedEndDate) <= 0

  return (
    <DatePicker
      {...rest}
      endDate={hasEndDate ? transformedEndDate : undefined}
      numberOfMonths={numberOfMonths}
      onChange={onChange}
      restrictedDatesList={restrictedDatesList}
      startDate={startDate ? transformedStartDate : undefined}
      scrollElementRef={scrollElementRef}
    />
  )
}

export default ControlDatePicker
